import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthProvider';
import React, { useState, useEffect } from "react";
import PrivateRoute from './components/PrivateRoute';
import logo from './logo.svg';
import './App.css';
import AdminLayout from './components/AdminLayout';
import PesertaLayout from './components/PesertaLayout';
import LoginForm from './components/LoginForm';
import PesertaUploadPembayaran from './pages/PesertaUploadPembayaran';
import Register from './components/Register';
import AdminMonitoringPembayaran from './pages/AdminMonitoringPembayaran';
import AdminEvent from './pages/AdminEvent';
import AdminMonitoringPeserta from './pages/AdminMonitoringPeserta';
import PesertaInfoEvent from './pages/PesertaInfoEvent';
import AdminAccomodation from "./pages/AdminAccomodation";
import AdminAudienceCategory from "./pages/AdminAudienceCategory";
import AdminAudienceCategoryDetail from "./pages/AdminAudienceCategoryDetail";
import AdminHotel from "./pages/AdminHotel";
import AdminWorkshop from "./pages/AdminWorkshop";
import PesertaProfile from "./pages/PesertaProfile";
import AdminDashboard from "./pages/AdminDashboard";
import AdminEventPrice from "./pages/AdminEventPrice";
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './components/ResetPassword';
// import DashboardPublic from './components/DashboardPublic';
import AdminDashboard2 from "./pages/AdminDashboard2";
import DownloadReport from './components/report/DownloadReport';

function App() {
  return (
    <>
    
    <AuthProvider>
        <Router>
          <Routes>
            {/* <Route path="/" element={<Navigate to="/" replace />} /> */}

            <Route path="/" element={<LoginForm />} />
            <Route path="/register" element={<Register />} />
            {/* <Route path="/dashboard" element={<DashboardPublic />} /> */}
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword/>} />
            <Route
              path="/admin/*"
              element={
                <PrivateRoute allowedRoles={['ROLE_ADMIN']}>
                  <AdminLayout />
                </PrivateRoute>
              }
            >
              
              <Route index element={<AdminDashboard2 />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="dashboard2" element={<AdminDashboard2 />} />
              <Route path="monitoring-pembayaran" element={<AdminMonitoringPembayaran />} />
              <Route path="monitoring-peserta" element={<AdminMonitoringPeserta />} />
              <Route path="event-management" element={<AdminEvent />} />
              <Route path="accomodation" element={<AdminAccomodation />} />
              <Route path="audience-category" element={<AdminAudienceCategory />} />
              <Route path="audience-category-detail" element={<AdminAudienceCategoryDetail />} />
              <Route path="hotel" element={<AdminHotel />} />
              <Route path="workshop" element={<AdminWorkshop />} />
              <Route path="event-price" element={<AdminEventPrice />} /> 
              <Route path="download-report" element={<DownloadReport />} />

            </Route>

            <Route
              path="/peserta"
              element={
                <PrivateRoute allowedRoles={['ROLE_PESERTA']}>
                  <PesertaLayout />
                </PrivateRoute>
              }
            >
                {/* ✅ Ini adalah default/index route */}
              <Route index element={<PesertaProfile />} />
              <Route path="upload-pembayaran" element={<PesertaUploadPembayaran />} />
              <Route path="info-event" element={<PesertaInfoEvent />} />
              <Route path="profile" element={<PesertaProfile />} />
    
            </Route>

            
          </Routes>
        </Router>
      </AuthProvider>
    </>
  );
}

export default App;
